<span class="form-badge">
    {{'distance_to_empty' | translate}}
    ({{model.mileage && model.mileage.mileageUOM == mileageUOMEnum.Kilometre ? "km" : "m"}})
    {{model.mileage && model.mileage.nrAvailableDistance}}
</span>
